module.exports = __webpack_public_path__ + "img/18.cdf5d008.jpg";